var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDmMobile = function SvgDmMobile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96005 18.7209V20.64H4.80005V18.7271V18.72C5.48488 18.72 6.22444 18.7209 6.96005 18.7209Z",
    fill: "url(#paint0_linear_1026_3074)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95533 17.093H12.0566C13.5273 17.093 17.1553 17.0764 17.1553 11.9993C17.1553 6.92294 13.5127 6.89361 12.0566 6.89361H7.44333C7.15801 6.89162 6.95733 7.10961 6.95798 7.39959C6.95798 7.82091 6.95533 17.093 6.95533 17.093ZM4.80335 17.0817C4.80335 17.0817 4.79999 7.5089 4.79999 6.89894C4.80335 5.73166 5.71934 4.8004 6.89466 4.8004H12.008C13.5233 4.8004 19.2 4.80108 19.2 12.0067C19.2 19.2129 13.4787 19.2002 12.008 19.2002C12.008 19.2002 9.50531 19.1976 6.95533 19.1956C6.22131 19.1956 5.48334 19.1949 4.79999 19.1949C3.65533 19.1949 2.66333 19.1956 2.09998 19.1969C0.90867 19.2002 0 18.2456 0 17.1004V4.8004C0 2.13257 2.14266 0 4.80132 0C7.50265 0.00135285 10.434 0.00135285 11.9933 0.00135285C13.5527 0.00135285 24 0.00135315 24 11.9973C24 23.9933 13.4787 24 11.9933 24C10.508 24 7.20865 23.9973 6.89798 23.998C5.71934 24 4.79999 23.0447 4.79999 21.9001V20.6322H6.95533V21.4068C6.95533 21.6881 7.16865 21.8901 7.43265 21.8928C7.74065 21.8954 10.5433 21.8928 12.044 21.8928C13.544 21.8928 21.9587 21.8628 21.9587 11.998C21.9587 2.13257 13.5047 2.09257 12.0486 2.09257C10.5933 2.09257 5.65331 2.0999 4.85667 2.09257C3.39533 2.09257 2.15534 3.29314 2.15534 4.79305V16.6071C2.15534 16.8597 2.36266 17.093 2.64133 17.093H4.80335V17.0817Z",
    fill: "url(#paint1_linear_1026_3074)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1026_3074",
    x1: 5.88005,
    y1: 18.8735,
    x2: 5.88005,
    y2: 19.6134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C74B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1026_3074",
    x1: 24,
    y1: 0,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDmMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dm-mobile.43e9ec198145fea07f4d5bdaab7a795c.svg";